import "@/App.css";
import { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";

import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import TeamPanel from "./components/TeamPanel";
import ScrollToTop from "./components/ScrollToTop";
import Landing from "./pages/Landing";
import Foundation from "./pages/Foundation";
import Press from "./pages/Press";
// Policy pages are lazy-loaded — they're rarely visited but ~30 KB each
const RefundPolicy = lazy(() => import("./pages/RefundPolicy"));
const Terms = lazy(() => import("./pages/Terms"));
const Privacy = lazy(() => import("./pages/Privacy"));
const HowYourDonationIsUsed = lazy(() => import("./pages/HowYourDonationIsUsed"));

// Defined at module scope so React doesn't see a new object on every render.
const TOASTER_OPTIONS = {
  className:
    "!bg-[#1a1a1a] !text-[#fdfbf7] !border-0 !rounded-none !font-mono !text-xs !tracking-[0.15em] !uppercase",
};

function PageFallback() {
  return (
    <div
      data-testid="page-loading"
      className="min-h-[60vh] flex items-center justify-center bg-[#fdfbf7]"
    >
      <p className="font-mono text-[11px] tracking-[0.25em] uppercase text-[#4a4a4a]">
        Loading…
      </p>
    </div>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Navbar />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/foundation" element={<Foundation />} />
          {/* Shareable shortcut URLs */}
          <Route path="/donate" element={<Foundation focus="donate" />} />
          <Route path="/donate-now" element={<Foundation focus="donate" mode="one-time" />} />
          <Route path="/join-the-circle" element={<Foundation focus="donate" mode="monthly" />} />
          <Route path="/patrons-one-time" element={<Foundation focus="donate" mode="one-time" region="international" />} />
          <Route path="/patrons-monthly" element={<Foundation focus="donate" mode="monthly" region="international" />} />
          {/* Redirects for previously-shared URLs — kept forever for backwards compatibility */}
          <Route path="/international-donate-now" element={<Navigate to="/patrons-one-time" replace />} />
          <Route path="/international-join-the-circle" element={<Navigate to="/patrons-monthly" replace />} />
          <Route path="/fcc" element={<Foundation focus="fcc" />} />
          <Route path="/press" element={<Press />} />
          <Route
            path="/refund-policy"
            element={
              <Suspense fallback={<PageFallback />}>
                <RefundPolicy />
              </Suspense>
            }
          />
          <Route
            path="/terms"
            element={
              <Suspense fallback={<PageFallback />}>
                <Terms />
              </Suspense>
            }
          />
          <Route
            path="/privacy"
            element={
              <Suspense fallback={<PageFallback />}>
                <Privacy />
              </Suspense>
            }
          />
          <Route
            path="/how-your-donation-is-used"
            element={
              <Suspense fallback={<PageFallback />}>
                <HowYourDonationIsUsed />
              </Suspense>
            }
          />
        </Routes>
        <TeamPanel />
        <Footer />
        <Toaster position="bottom-right" toastOptions={TOASTER_OPTIONS} />
      </BrowserRouter>
    </div>
  );
}

export default App;
